import { render, staticRenderFns } from "./FlowyNavMenuItem.vue?vue&type=template&id=edfd0bc8"
import script from "./FlowyNavMenuItem.vue?vue&type=script&lang=js"
export * from "./FlowyNavMenuItem.vue?vue&type=script&lang=js"
import style0 from "./FlowyNavMenuItem.vue?vue&type=style&index=0&id=edfd0bc8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports